class NumberUtils
{
    static isWithinDistance(a: number, b: number, distance: number): boolean {
        return Math.abs(a - b) <= distance;
    }
}

export default NumberUtils;